import {
    STROLLER_FEATURE_ADJUSTABLE_HANDLE,
    STROLLER_FEATURE_ALL_WHEELS_ARE_DOUBLE,
    STROLLER_FEATURE_ARTIFICIAL_WHEEL_TYPE,
    STROLLER_FEATURE_AUTOLOCK,
    STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_EXTENDED,
    STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_POSITIONED,
    STROLLER_FEATURE_BACK_SUPPORT_LENGTH_IN_CM,
    STROLLER_FEATURE_BACK_SUPPORT_POSITIONING_TYPE,
    STROLLER_FEATURE_BACK_SUPPORT_POSITIONS,
    STROLLER_FEATURE_BIG_SHOPPING_BASKET,
    STROLLER_FEATURE_BUCKET_SEAT,
    STROLLER_FEATURE_BUCKET_SECOND_SEAT,
    STROLLER_FEATURE_BUILTIN_SPEAKER,
    STROLLER_FEATURE_BUMPER_BAR,
    STROLLER_FEATURE_BUMPER_BAR_CAN_BE_POSITIONED,
    STROLLER_FEATURE_BUMPER_BAR_CAN_BE_REMOVED,
    STROLLER_FEATURE_BUMPER_BAR_TYPE,
    STROLLER_FEATURE_CAN_BE_CONVERTED_TO_A_DOUBLE,
    STROLLER_FEATURE_CAN_BE_CONVERTED_TO_A_SINGLE,
    STROLLER_FEATURE_CAN_BE_PULLED_BEHIND,
    STROLLER_FEATURE_CAR_SEAT_CAN_BE_ATTACHED,
    STROLLER_FEATURE_CAR_SEAT_COMPATIBILITY_MOST_BRANDS,
    STROLLER_FEATURE_CAR_SEAT_COMPATIBILITY_ROEMER,
    STROLLER_FEATURE_CAR_SEAT_HAS_TO_BE_BOUGHT,
    STROLLER_FEATURE_CARRYCOT_CAN_BE_ATTACHED,
    STROLLER_FEATURE_CARRYCOT_DIMS_IN_CM,
    STROLLER_FEATURE_CARRYCOT_HAS_HANDLE,
    STROLLER_FEATURE_CARRYCOT_HAS_VENTILATION,
    STROLLER_FEATURE_CARRYCOT_USABLE_IN_CAR,
    STROLLER_FEATURE_CARRYCOT_WITH_CRADLE,
    STROLLER_FEATURE_CENTRAL_BRAKE_PRESENT,
    STROLLER_FEATURE_CENTRAL_BRAKE_SYSTEM,
    STROLLER_FEATURE_CHECKED_BAGGAGE,
    STROLLER_FEATURE_COMBO_ONLY,
    STROLLER_FEATURE_CUPHOLDER_POSSIBILITY,
    STROLLER_FEATURE_DISCONTINUED_YEAR,
    STROLLER_FEATURE_EXTENDABLE_HOOD,
    STROLLER_FEATURE_FOLDABLE_CARRYCOT,
    STROLLER_FEATURE_FOLDED_DIMENSIONS_IN_CM,
    STROLLER_FEATURE_FOLDING_SYSTEM,
    STROLLER_FEATURE_FOLDS_BY_ITSELF,
    STROLLER_FEATURE_FOLDS_WITH_THE_SEAT_ATTACHED,
    STROLLER_FEATURE_FOLDS_WITH_THE_SEAT_IN_REVERSE,
    STROLLER_FEATURE_FOOT_REST,
    STROLLER_FEATURE_FRONT_WHEEL_TYPE,
    STROLLER_FEATURE_FRONT_WHEELS_DIAMETER_IN_CM,
    STROLLER_FEATURE_FULLY_FLEDGED_SECOND_SEAT,
    STROLLER_FEATURE_HANDLE_HEIGHT_IN_CM,
    STROLLER_FEATURE_HANDLE_MATERIAL,
    STROLLER_FEATURE_HAS_CARRY_HANDLE,
    STROLLER_FEATURE_HEIGHT_ADJUSTABLE_SEAT,
    STROLLER_FEATURE_HIGHER_SEAT_POSITION,
    STROLLER_FEATURE_HOOD_FEATURES_A_SUN_VISOR,
    STROLLER_FEATURE_INCLINABLE_CARRYCOT,
    STROLLER_FEATURE_LED_LIGHTING,
    STROLLER_FEATURE_LEG_REST_CAN_BE_EXTENDED,
    STROLLER_FEATURE_LEG_REST_CAN_BE_POSITIONED,
    STROLLER_FEATURE_LEG_REST_POSITIONS,
    STROLLER_FEATURE_MANUAL_BRAKE_PRESENT,
    STROLLER_FEATURE_MAXIMUM_LOAD_PER_1ST_CHILD_IN_KG,
    STROLLER_FEATURE_MAXIMUM_LOAD_PER_2ND_CHILD_IN_KG,
    STROLLER_FEATURE_MAXIMUM_LOAD_PER_CHILD_IN_KG,
    STROLLER_FEATURE_MEMORY_BUTTON,
    STROLLER_FEATURE_MISSING_SITTING_PART,
    STROLLER_FEATURE_MOTORIZED,
    STROLLER_FEATURE_NUMBER_OF_DOUBLE_WHEELS,
    STROLLER_FEATURE_NUMBER_OF_WHEELS,
    STROLLER_FEATURE_ONE_HAND_FOLDING,
    STROLLER_FEATURE_ONE_HAND_POSITIONING,
    STROLLER_FEATURE_ORIGIN_COUNTRIES,
    STROLLER_FEATURE_PARENT_TRAY_ORGANIZER,
    STROLLER_FEATURE_PLATFORM_MATERIAL,
    STROLLER_FEATURE_POSSIBILITY_OF_TERRAIN_WHEELS,
    STROLLER_FEATURE_PRAMETTE_SEAT_2IN1,
    STROLLER_FEATURE_REAR_WHEEL_TYPE,
    STROLLER_FEATURE_REAR_WHEELS_DIAMETER_IN_CM,
    STROLLER_FEATURE_RECOMMENDED_AGE,
    STROLLER_FEATURE_RETROREFLECTOR,
    STROLLER_FEATURE_ROOF_PRESENT,
    STROLLER_FEATURE_ROTATING_SEAT,
    STROLLER_FEATURE_ROTATING_SECOND_SEAT,
    STROLLER_FEATURE_ROTATING_WHEELS,
    STROLLER_FEATURE_SEAT_DIMS_IN_CM,
    STROLLER_FEATURE_SEAT_FABRICS_CAN_BE_TAKEN_OFF,
    STROLLER_FEATURE_SEAT_SAFETY_INDICATOR,
    STROLLER_FEATURE_SEAT_SURFACE_TOTAL_LENGTH_IN_CM,
    STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_CAN_BE_POSITIONED,
    STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_LENGTH_IN_CM,
    STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_POSITIONING_TYPE,
    STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_POSITIONS,
    STROLLER_FEATURE_SECOND_SEAT_BUMPER_BAR,
    STROLLER_FEATURE_SECOND_SEAT_DIMS_IN_CM,
    STROLLER_FEATURE_SECOND_SEAT_FOOT_REST,
    STROLLER_FEATURE_SECOND_SEAT_LEG_REST,
    STROLLER_FEATURE_SECOND_SEAT_ONE_HAND_POSITIONING,
    STROLLER_FEATURE_SECOND_SEAT_RECOMMENDED_AGE,
    STROLLER_FEATURE_SECOND_SEAT_ROOF_PRESENT,
    STROLLER_FEATURE_SECOND_SEAT_SURFACE_TOTAL_LENGTH_IN_CM,
    STROLLER_FEATURE_SHOPPING_BASKET,
    STROLLER_FEATURE_SHOPPING_BASKET_CAPACITY_IN_KG,
    STROLLER_FEATURE_SHOPPING_BASKET_CLOSABLE,
    STROLLER_FEATURE_SPORTGOLF_ONLY,
    STROLLER_FEATURE_STANDING_FOLD,
    STROLLER_FEATURE_SUPPLIED_CAPE,
    STROLLER_FEATURE_SUPPLIED_CHANGING_BAG,
    STROLLER_FEATURE_SUPPLIED_FOOTMUFF,
    STROLLER_FEATURE_SUPPLIED_MOSQUITO_NET,
    STROLLER_FEATURE_SUPPLIED_PAD,
    STROLLER_FEATURE_SUPPLIED_TRANSPORT_BAG,
    STROLLER_FEATURE_SUPPLIED_WHEEL_PROTECTIVE_SLEEVES,
    STROLLER_FEATURE_SUSPENDED_WHEELS,
    STROLLER_FEATURE_SUSPENSION,
    STROLLER_FEATURE_SUSPENSION_TYPE,
    STROLLER_FEATURE_SWING_AWAY_BUMPER_BAR,
    STROLLER_FEATURE_SWINGING,
    STROLLER_FEATURE_TWO_CAR_SEATS_CAN_BE_ATTACHED,
    STROLLER_FEATURE_TYPE,
    STROLLER_FEATURE_TYPE_OF_HANDLE_ADJUSTMENT,
    STROLLER_FEATURE_UNFOLDED_DIMENSIONS_IN_CM,
    STROLLER_FEATURE_WEIGHT_IN_KG,
    STROLLER_FEATURE_WHEEL_DIRECTION_MEMORY,
    STROLLER_FEATURE_WHEEL_MUDGUARDS,
    STROLLER_FEATURE_WHEELS_CAN_BE_ARRESTED,
    STROLLER_FEATURE_WHEELS_CAN_BE_REMOVED,
    STROLLER_FEATURE_WIPE_CLEAN_LEG_REST,
} from 'mk/autogenerated/translations/constants.882f76fd018bf824b502edaa386c03b1'

export const FEATURE_LABEL_MESSAGES = {
    adjustable_handle: STROLLER_FEATURE_ADJUSTABLE_HANDLE,
    all_wheels_are_double: STROLLER_FEATURE_ALL_WHEELS_ARE_DOUBLE,
    artificial_wheel_type: STROLLER_FEATURE_ARTIFICIAL_WHEEL_TYPE,
    autolock: STROLLER_FEATURE_AUTOLOCK,
    back_support_can_be_extended: STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_EXTENDED,
    back_support_can_be_in_lying_position: STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    back_support_can_be_positioned: STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_POSITIONED,
    back_support_length_in_cm: STROLLER_FEATURE_BACK_SUPPORT_LENGTH_IN_CM,
    back_support_positioning_type: STROLLER_FEATURE_BACK_SUPPORT_POSITIONING_TYPE,
    back_support_positions: STROLLER_FEATURE_BACK_SUPPORT_POSITIONS,        // deprecated
    back_support_positions_l: STROLLER_FEATURE_BACK_SUPPORT_POSITIONS,
    big_shopping_basket: STROLLER_FEATURE_BIG_SHOPPING_BASKET,
    bucket_seat: STROLLER_FEATURE_BUCKET_SEAT,
    bucket_second_seat: STROLLER_FEATURE_BUCKET_SECOND_SEAT,
    builtin_speaker: STROLLER_FEATURE_BUILTIN_SPEAKER,
    bumper_bar: STROLLER_FEATURE_BUMPER_BAR,
    bumper_bar_can_be_positioned: STROLLER_FEATURE_BUMPER_BAR_CAN_BE_POSITIONED,
    bumper_bar_can_be_removed: STROLLER_FEATURE_BUMPER_BAR_CAN_BE_REMOVED,
    bumper_bar_type: STROLLER_FEATURE_BUMPER_BAR_TYPE,
    can_be_converted_to_a_double: STROLLER_FEATURE_CAN_BE_CONVERTED_TO_A_DOUBLE,
    can_be_converted_to_a_single: STROLLER_FEATURE_CAN_BE_CONVERTED_TO_A_SINGLE,
    can_be_pulled_behind: STROLLER_FEATURE_CAN_BE_PULLED_BEHIND,
    car_seat_can_be_attached: STROLLER_FEATURE_CAR_SEAT_CAN_BE_ATTACHED,
    car_seat_compatibility_most_brands: STROLLER_FEATURE_CAR_SEAT_COMPATIBILITY_MOST_BRANDS,
    car_seat_compatibility_roemer: STROLLER_FEATURE_CAR_SEAT_COMPATIBILITY_ROEMER,
    car_seat_has_to_be_bought: STROLLER_FEATURE_CAR_SEAT_HAS_TO_BE_BOUGHT,
    carrycot_can_be_attached: STROLLER_FEATURE_CARRYCOT_CAN_BE_ATTACHED,
    carrycot_dims_in_cm: STROLLER_FEATURE_CARRYCOT_DIMS_IN_CM,
    carrycot_has_handle: STROLLER_FEATURE_CARRYCOT_HAS_HANDLE,
    carrycot_has_ventilation: STROLLER_FEATURE_CARRYCOT_HAS_VENTILATION,
    carrycot_usable_in_car: STROLLER_FEATURE_CARRYCOT_USABLE_IN_CAR,
    carrycot_with_cradle: STROLLER_FEATURE_CARRYCOT_WITH_CRADLE,
    central_brake_present: STROLLER_FEATURE_CENTRAL_BRAKE_PRESENT,
    central_brake_system: STROLLER_FEATURE_CENTRAL_BRAKE_SYSTEM,
    checked_baggage: STROLLER_FEATURE_CHECKED_BAGGAGE,
    combo_only: STROLLER_FEATURE_COMBO_ONLY,
    cupholder_possibility: STROLLER_FEATURE_CUPHOLDER_POSSIBILITY,
    discontinued_year: STROLLER_FEATURE_DISCONTINUED_YEAR,
    extendable_hood: STROLLER_FEATURE_EXTENDABLE_HOOD,
    foldable_carrycot: STROLLER_FEATURE_FOLDABLE_CARRYCOT,
    folded_dimensions_in_cm: STROLLER_FEATURE_FOLDED_DIMENSIONS_IN_CM,
    folding_system: STROLLER_FEATURE_FOLDING_SYSTEM,
    folds_by_itself: STROLLER_FEATURE_FOLDS_BY_ITSELF,
    folds_with_the_seat_attached: STROLLER_FEATURE_FOLDS_WITH_THE_SEAT_ATTACHED,
    folds_with_the_seat_in_reverse: STROLLER_FEATURE_FOLDS_WITH_THE_SEAT_IN_REVERSE,
    foot_rest: STROLLER_FEATURE_FOOT_REST,
    front_wheel_type: STROLLER_FEATURE_FRONT_WHEEL_TYPE,
    front_wheels_diameter_in_cm: STROLLER_FEATURE_FRONT_WHEELS_DIAMETER_IN_CM,
    front_wheels_diameter_in_cm_l: STROLLER_FEATURE_FRONT_WHEELS_DIAMETER_IN_CM,
    fully_fledged_second_seat: STROLLER_FEATURE_FULLY_FLEDGED_SECOND_SEAT,
    handle_height_in_cm: STROLLER_FEATURE_HANDLE_HEIGHT_IN_CM,
    handle_material: STROLLER_FEATURE_HANDLE_MATERIAL,
    has_carry_handle: STROLLER_FEATURE_HAS_CARRY_HANDLE,
    height_adjustable_seat: STROLLER_FEATURE_HEIGHT_ADJUSTABLE_SEAT,
    higher_seat_position: STROLLER_FEATURE_HIGHER_SEAT_POSITION,
    hood_features_a_sun_visor: STROLLER_FEATURE_HOOD_FEATURES_A_SUN_VISOR,
    inclinable_carrycot: STROLLER_FEATURE_INCLINABLE_CARRYCOT,
    led_lighting: STROLLER_FEATURE_LED_LIGHTING,
    leg_rest_can_be_extended: STROLLER_FEATURE_LEG_REST_CAN_BE_EXTENDED,
    leg_rest_can_be_positioned: STROLLER_FEATURE_LEG_REST_CAN_BE_POSITIONED,
    leg_rest_positions: STROLLER_FEATURE_LEG_REST_POSITIONS,
    manual_brake_present: STROLLER_FEATURE_MANUAL_BRAKE_PRESENT,
    maximum_load_per_1st_child_in_kg: STROLLER_FEATURE_MAXIMUM_LOAD_PER_1ST_CHILD_IN_KG,
    maximum_load_per_2nd_child_in_kg: STROLLER_FEATURE_MAXIMUM_LOAD_PER_2ND_CHILD_IN_KG,
    maximum_load_per_child_in_kg: STROLLER_FEATURE_MAXIMUM_LOAD_PER_CHILD_IN_KG,
    memory_button: STROLLER_FEATURE_MEMORY_BUTTON,
    missing_sitting_part: STROLLER_FEATURE_MISSING_SITTING_PART,
    motorized: STROLLER_FEATURE_MOTORIZED,
    number_of_double_wheels: STROLLER_FEATURE_NUMBER_OF_DOUBLE_WHEELS,
    number_of_wheels: STROLLER_FEATURE_NUMBER_OF_WHEELS,
    number_of_wheels_l: STROLLER_FEATURE_NUMBER_OF_WHEELS,
    one_hand_folding: STROLLER_FEATURE_ONE_HAND_FOLDING,
    one_hand_positioning: STROLLER_FEATURE_ONE_HAND_POSITIONING,
    origin_countries: STROLLER_FEATURE_ORIGIN_COUNTRIES,
    parent_tray_organizer: STROLLER_FEATURE_PARENT_TRAY_ORGANIZER,
    platform_material: STROLLER_FEATURE_PLATFORM_MATERIAL,
    possibility_of_terrain_wheels: STROLLER_FEATURE_POSSIBILITY_OF_TERRAIN_WHEELS,
    pramette_seat_2in1: STROLLER_FEATURE_PRAMETTE_SEAT_2IN1,
    rear_wheel_type: STROLLER_FEATURE_REAR_WHEEL_TYPE,
    rear_wheels_diameter_in_cm: STROLLER_FEATURE_REAR_WHEELS_DIAMETER_IN_CM,
    rear_wheels_diameter_in_cm_l: STROLLER_FEATURE_REAR_WHEELS_DIAMETER_IN_CM,
    recommended_age: STROLLER_FEATURE_RECOMMENDED_AGE,
    retroreflector: STROLLER_FEATURE_RETROREFLECTOR,
    roof_present: STROLLER_FEATURE_ROOF_PRESENT,
    rotating_seat: STROLLER_FEATURE_ROTATING_SEAT,
    rotating_second_seat: STROLLER_FEATURE_ROTATING_SECOND_SEAT,
    rotating_wheels: STROLLER_FEATURE_ROTATING_WHEELS,
    seat_dims_in_cm: STROLLER_FEATURE_SEAT_DIMS_IN_CM,
    seat_fabrics_can_be_taken_off: STROLLER_FEATURE_SEAT_FABRICS_CAN_BE_TAKEN_OFF,
    seat_safety_indicator: STROLLER_FEATURE_SEAT_SAFETY_INDICATOR,
    seat_surface_total_length_in_cm: STROLLER_FEATURE_SEAT_SURFACE_TOTAL_LENGTH_IN_CM,
    second_seat_back_support_can_be_in_lying_position: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    second_seat_back_support_can_be_positioned: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_CAN_BE_POSITIONED,
    second_seat_back_support_length_in_cm: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_LENGTH_IN_CM,
    second_seat_back_support_positioning_type: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_POSITIONING_TYPE,
    second_seat_back_support_positions: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_POSITIONS,    // deprecated
    second_seat_back_support_positions_l: STROLLER_FEATURE_SECOND_SEAT_BACK_SUPPORT_POSITIONS,
    second_seat_bumper_bar: STROLLER_FEATURE_SECOND_SEAT_BUMPER_BAR,
    second_seat_dims_in_cm: STROLLER_FEATURE_SECOND_SEAT_DIMS_IN_CM,
    second_seat_foot_rest: STROLLER_FEATURE_SECOND_SEAT_FOOT_REST,
    second_seat_leg_rest: STROLLER_FEATURE_SECOND_SEAT_LEG_REST,
    second_seat_one_hand_positioning: STROLLER_FEATURE_SECOND_SEAT_ONE_HAND_POSITIONING,
    second_seat_recommended_age: STROLLER_FEATURE_SECOND_SEAT_RECOMMENDED_AGE,
    second_seat_roof_present: STROLLER_FEATURE_SECOND_SEAT_ROOF_PRESENT,
    second_seat_surface_total_length_in_cm: STROLLER_FEATURE_SECOND_SEAT_SURFACE_TOTAL_LENGTH_IN_CM,
    shopping_basket: STROLLER_FEATURE_SHOPPING_BASKET,
    shopping_basket_capacity_in_kg: STROLLER_FEATURE_SHOPPING_BASKET_CAPACITY_IN_KG,
    shopping_basket_closable: STROLLER_FEATURE_SHOPPING_BASKET_CLOSABLE,
    sportgolf_only: STROLLER_FEATURE_SPORTGOLF_ONLY,
    standing_fold: STROLLER_FEATURE_STANDING_FOLD,
    supplied_cape: STROLLER_FEATURE_SUPPLIED_CAPE,
    supplied_changing_bag: STROLLER_FEATURE_SUPPLIED_CHANGING_BAG,
    supplied_footmuff: STROLLER_FEATURE_SUPPLIED_FOOTMUFF,
    supplied_mosquito_net: STROLLER_FEATURE_SUPPLIED_MOSQUITO_NET,
    supplied_pad: STROLLER_FEATURE_SUPPLIED_PAD,
    supplied_transport_bag: STROLLER_FEATURE_SUPPLIED_TRANSPORT_BAG,
    supplied_wheel_protective_sleeves: STROLLER_FEATURE_SUPPLIED_WHEEL_PROTECTIVE_SLEEVES,
    suspended_wheels: STROLLER_FEATURE_SUSPENDED_WHEELS,
    suspension: STROLLER_FEATURE_SUSPENSION,
    suspension_type: STROLLER_FEATURE_SUSPENSION_TYPE,
    swing_away_bumper_bar: STROLLER_FEATURE_SWING_AWAY_BUMPER_BAR,
    swinging: STROLLER_FEATURE_SWINGING,
    two_car_seats_can_be_attached: STROLLER_FEATURE_TWO_CAR_SEATS_CAN_BE_ATTACHED,
    type: STROLLER_FEATURE_TYPE,
    type_of_handle_adjustment: STROLLER_FEATURE_TYPE_OF_HANDLE_ADJUSTMENT,
    unfolded_dimensions_in_cm: STROLLER_FEATURE_UNFOLDED_DIMENSIONS_IN_CM,
    weight_in_kg: STROLLER_FEATURE_WEIGHT_IN_KG,
    wheel_direction_memory: STROLLER_FEATURE_WHEEL_DIRECTION_MEMORY,
    wheel_mudguards: STROLLER_FEATURE_WHEEL_MUDGUARDS,
    wheels_can_be_arrested: STROLLER_FEATURE_WHEELS_CAN_BE_ARRESTED,
    wheels_can_be_removed: STROLLER_FEATURE_WHEELS_CAN_BE_REMOVED,
    wipe_clean_leg_rest: STROLLER_FEATURE_WIPE_CLEAN_LEG_REST,
};
